import * as action from 'actions';
import * as onlineStoreAction from 'actions/onlineStore';
import { delay } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as onlineStoreApi from 'api/onlineStore';
import * as actNotif from 'actions/notifications';
import {
  ONLINE_STORE_START_EXPORT_PRODUCT_FLOW,
  ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW,
} from 'actions/onlineStore/constants';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import * as fbClevertap from 'clevertap/onlineStore/facebook';
import * as googleClevertap from 'clevertap/onlineStore/google';

const clevertapMap = {
  [ONLINE_STORE_CHANNEL.FACEBOOK]: {
    success: fbClevertap.fbProductUploadExportSuccess,
    failure: fbClevertap.fbProductUploadExportFailure,
  },
  [ONLINE_STORE_CHANNEL.GOOGLE]: {
    success: googleClevertap.googleProductUploadExportSuccess,
    failure: googleClevertap.googleProductUploadExportFailure,
  },
};

function* getClevertap() {
  const channel = yield select(
    state => state.onlineStore.shop.shopDetail.channel
  );

  return clevertapMap[channel];
}

export function* startProductExportFlow({ payload }) {
  const { shopId } = payload;
  const clevertap = yield getClevertap();

  yield put(action.showLoadingSpinner(true));

  try {
    const { export_id } = yield fetch(onlineStoreApi.initiateProductExport, {
      shopId,
    });

    yield put(onlineStoreAction.setProductExportId(export_id));

    while (true) {
      yield delay(5000, true);

      const exportId = yield getExportId();
      if (!exportId) {
        break;
      }

      yield put(onlineStoreAction.startPostProductExportFlow(shopId));
    }
  } catch (e) {
    clevertap.failure(e.message);
    yield put(actNotif.error('Please try again later.'));
  } finally {
    yield put(action.showLoadingSpinner(false));
  }
}

function* startPostProductExportFlow({ payload }) {
  const { shopId } = payload;
  const clevertap = yield getClevertap();
  const exportId = yield getExportId();

  if (!exportId) {
    return;
  }

  const { status, url } = yield fetch(onlineStoreApi.getProductExportFileUrl, {
    shopId,
    exportId,
  });

  if (status === 'DONE') {
    window.location.href = url;
    clevertap.success();
    yield put(onlineStoreAction.setProductExportId(false));
    yield put(action.showLoadingSpinner(false));
  }
}

function* getExportId() {
  return yield select(state => state.onlineStore.productExport.exportId);
}

function* fetch(action, params) {
  const response = yield call(action, params);
  const { status, data } = response;
  if (status !== 200) {
    throw response;
  }

  return data;
}

export default function* saga() {
  yield takeLatest(
    ONLINE_STORE_START_EXPORT_PRODUCT_FLOW,
    startProductExportFlow
  );
  yield takeLatest(
    ONLINE_STORE_START_POST_EXPORT_PRODUCT_FLOW,
    startPostProductExportFlow
  );
}
